import React, {useState} from 'react'
import ManageServiceIds from '../components/serviceID-manager'
import ManageProducts from '../components/product-grp-manager'

const TABS = [
  {id: 'products', label: 'Manage products'},
  {id: 'serviceId', label: 'Manage service IDs'},
]

export default function App() {
  const [tab, setTab] = useState('products')

  return (
    <div
      style={{
        fontFamily: "'Inter', system-ui, sans-serif",
        minHeight: '100%',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderBottom: '1px solid #E5E7EB',
          display: 'flex',
          alignItems: 'center',
          height: 48,
        }}
      >
        {TABS.map(({id, label}) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            style={{
              padding: '0 18px',
              height: '100%',
              border: 'none',
              borderBottom:
                tab === id ? `2px solid ff5000` : '2px solid transparent',
              background: 'transparent',
              fontSize: 13,
              fontWeight: tab === id ? 600 : 400,
              color: tab === id ? '#ff5000' : '#6B7280',
              cursor: 'pointer',
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === 'serviceId' && <ManageServiceIds />}
      {tab === 'products' && <ManageProducts />}
    </div>
  )
}
